export class DogBreedInfo {
  constructor(
    public id: string,
    public name: string,
    public description: string,
    public lifeSpan: string,
    public weightKg: string,
    public imageUrl: string,
    public dog_friendly: string,
    public playfulness: string,
    public child_friendly: string,
    public energy_level: string,
    public trainability: string,
    public stranger_friendly: string,
    public shedding_level: string,
    public barking: string,
    public coat_length: string,
    public drooling: string,
  ) { }
}

export class CatBreedInfo {
  constructor(
    public id: string,
    public name: string,
    public description: string,
    public lifeSpan: string,
    public temperament: string,
    public origin: string,
    public weightKg: string,
    public imageUrl: string,
    public dog_friendly: string,
    public affection_level: string,
    public child_friendly: string,
    public energy_level: string,
    public intelligence: string,
    public stranger_friendly: string,
    public shedding_level: string,
    public vocalisation: string,
    public social_needs: string,
    public health_issues: string,
  ) { }
}